import { RoleId } from '../enums/role.enum';

export const ROLE_TRANSLATION_KEY: Record<RoleId, string> = {
  [RoleId.Admin]: 'common.userRoles.admin',
  [RoleId.DevelopmentChief]: 'common.userRoles.developmentChief',
  [RoleId.Instructor]: 'common.userRoles.instructor',
  [RoleId.NationalOffice]: 'common.userRoles.nationalOffice',
};
